import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../utils/api';

const DASHBOARD_STATS_QUERY_KEY = ['dashboard-stats'];

export const useDashboardStats = () => {
  return useQuery({
    queryKey: DASHBOARD_STATS_QUERY_KEY,
    queryFn: () => apiClient.getDashboardStats(),
    staleTime: 5 * 60 * 1000, // 5 minutes
    refetchOnWindowFocus: false,
  });
};
